import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VhIconComponent } from '../icon/icon.component';
import type { VhIconName } from '../icon/vh-icons';

export type VhBadgeTone =
  | 'neutral'
  | 'brand'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'accent';
export type VhBadgeSize = 'sm' | 'md';

/**
 * Small pill used for product badges (New / Featured / Low stock) and
 * vendor markers (Verified). Tone maps to the token palette so light /
 * dark themes swap cleanly.
 */
@Component({
  selector: 'vh-badge',
  standalone: true,
  imports: [VhIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (icon(); as iconName) {
      <vh-icon [name]="iconName" size="sm" />
    }
    <ng-content />
  `,
  styleUrl: './badge.component.scss',
  host: {
    '[class]': '"vh-badge vh-badge--" + tone() + " vh-badge--" + size()',
  },
})
export class VhBadgeComponent {
  readonly tone = input<VhBadgeTone>('neutral');
  readonly size = input<VhBadgeSize>('sm');
  readonly icon = input<VhIconName | null>(null);
}
